// removed by extract-text-webpack-plugin
module.exports = {"verifyBox":"qempo_Security_verifyBox-3CMtQ1f","verifyImg":"qempo_Security_verifyImg-2Z1wEqs","lightBlue":"qempo_Security_lightBlue-ahaG_4i","later":"qempo_Security_later-1D2dhPO"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/preferences/security/components/Security.scss
// module id = 1382
// module chunks = 0